import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#005A8C] text-white py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Left Section: Logo and Map */}
          <div>
            <h2 className="text-lg font-bold mb-4">Sanjay k Nathani & Co.</h2>
            <div className="w-full h-40 bg-gray-200 rounded-md overflow-hidden">
              {/* Placeholder for Map */}
              <iframe
                src="https://maps.google.com/maps?q=Sanjay%20k%20Nathani&t=&z=13&ie=UTF8&iwloc=&output=embed"
                title="Map"
                className="w-full h-full"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* Quick Menu */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Menu</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:underline">
                  Home
                </Link>
              </li>
              <li> Our Service</li>
              <li>
                <Link to="/about" className="hover:underline">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/career" className="hover:underline">
                  Career
                </Link>
              </li>
              <li>
                <Link to="/contactus" className="hover:underline">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>Auditing Service </li>
              <li>Business Compliance</li>
              <li>Accounting</li>
              <li> Bookkeeping Service</li>
              <li> Useful Links</li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Information</h3>
            <ul className="space-y-3 text-sm">
              {/* Address */}
              <li className="flex items-start space-x-2">
                <FaMapMarkerAlt className="mt-1" />
                <span>A3, Sanjay k Nathani & Co., Subhashpark society, B/h Avadh viceroy , Sarthana-Jakatnaka, Surat - 395013</span>
              </li>

              {/* Phone */}
              <li className="flex items-center space-x-2">
                <FaPhoneAlt />
                <span>+91 81415 14454</span>
              </li>

              {/* Email */}
              <li className="flex items-center space-x-2">
                <FaEnvelope />
                <span>kkrca@gmail.com</span>
              </li>

              {/* Social Media Icons */}
              <li className="flex space-x-4 mt-2">
                {/* Replace # with actual links */}
                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FaFacebook className="hover:text-gray-300 cursor-pointer" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaInstagram className="hover:text-gray-300 cursor-pointer" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <FaTwitter className="hover:text-gray-300 cursor-pointer" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-400 mt-8 pt-4 text-center text-sm text-gray-300">
          &copy; 2025 Godhani Technology
        </div>
      </div>
    </footer>
  );
};

export default Footer;
